import { useContext } from "react";
import { MasonryLayoutContext } from "./MasonryLayoutProvider";

export const useMasonryColumns = () => useContext(MasonryLayoutContext);
